Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.CustomWidth = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _utils = require("../../utils");
var CustomWidth = exports.CustomWidth = 649;
var useStyles = exports.useStyles = function useStyles() {
  var _useWindowDimensions = (0, _utils.useWindowDimensions)(),
    width = _useWindowDimensions.width;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    spacing = _STYLES$useStyles.spacing;
  var logo = {
    marginBottom: spacing.l,
    width: width <= CustomWidth ? 186 : 304,
    height: width <= CustomWidth ? 46 : 75
  };
  var headerImageContainer = {
    minHeight: 100,
    width: '100%',
    overflow: _reactNative.Platform.OS === 'web' ? 'hidden' : undefined,
    alignSelf: 'center',
    alignItems: 'center',
    position: 'relative'
  };
  var image_Header = {
    width: width <= CustomWidth ? 445 : 790,
    height: width <= CustomWidth ? 445 * (171 / 790) : 171,
    position: width <= CustomWidth ? 'absolute' : 'relative',
    top: width <= CustomWidth ? 0 : undefined,
    left: width <= CustomWidth ? '50%' : undefined,
    transform: width <= CustomWidth ? [{
      translateX: -200
    }] : undefined
  };
  var contentContainer = {
    alignItems: 'center',
    justifyContent: 'center',
    padding: spacing.normal,
    width: '100%',
    top: width <= CustomWidth ? 0 : -70
  };
  var footerImageContainer = {
    marginTop: 'auto',
    marginBottom: _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(spacing.page.padding.paddingBottom, ")") : -1 * spacing.page.padding.paddingBottom,
    overflow: 'hidden',
    alignItems: 'center',
    width: '100%',
    paddingTop: width <= CustomWidth ? 138 : 285
  };
  var image_PlantKeyMan = Object.assign({
    position: 'absolute'
  }, width <= CustomWidth ? {
    bottom: -29,
    marginBottom: -138,
    left: '50%',
    transform: [{
      translateX: -200
    }, {
      scaleX: -1
    }],
    width: 358,
    height: 276
  } : {
    top: 0,
    left: '50%',
    transform: [{
      translateX: -478
    }, {
      scaleX: -1
    }],
    width: 852,
    height: 590
  });
  var styles = _reactNative.StyleSheet.create({
    contentContainer: contentContainer,
    heading: {
      textAlign: 'center',
      marginBottom: spacing.m,
      fontSize: width <= CustomWidth ? _styles.STYLES.fontSize.m : _styles.STYLES.fontSize.l,
      lineHeight: _styles.STYLES.lineHeight.m
    },
    signUpButton: {
      marginBottom: spacing.m
    },
    signInTextContainer: {
      textAlign: 'center',
      marginBottom: spacing.m
    },
    signInText: {
      color: colors.brand
    },
    findOutMore: {
      marginTop: spacing.xl,
      color: colors.brand
    },
    logo: logo,
    headerImageContainer: headerImageContainer,
    footerImageContainer: footerImageContainer,
    image_Header: image_Header,
    image_PlantKeyMan: image_PlantKeyMan
  });
  return {
    styles: styles
  };
};